export const CartActionTypes = {
	TOGGLE_HIDDEN_CART: "TOGGLE_HIDDEN_CART",
	ADD_ITEM: "ADD_ITEM",
	REMOVE_ITEM: "REMOVE_ITEM", 
	DECREASE_ITEM: "DECREASE_ITEM"
};

export default CartActionTypes;
